// Base URLs for calling tech refresh microservices
export const commwebServiceBaseUrls: Record<string, string> = {
    unit1: 'https://unit-1.commercialweb.apps.test.ext.bcbssc.com/',
    unit2: 'https://unit-2.commercialweb.apps.test.ext.bcbssc.com/',
    unit3: 'https://unit-3.commercialweb.apps.test.ext.bcbssc.com/',
    unit4: 'https://unit-4.commercialweb.apps.test.ext.bcbssc.com/',
    unit5: 'https://unit-5.commercialweb.apps.test.ext.bcbssc.com/',
    unit6: 'https://unit-6.commercialweb.apps.test.ext.bcbssc.com/',
    unit7: 'https://unit-7.commercialweb.apps.test.ext.bcbssc.com/',
    unit8: 'https://unit-8.commercialweb.apps.test.ext.bcbssc.com/',
    system1: 'https://system-1.commercialweb.apps.test.ext.bcbssc.com/',
    system2: 'https://system-2.commercialweb.apps.test.ext.bcbssc.com/',
    system3: 'https://system-3.commercialweb.apps.test.ext.bcbssc.com/',
    system4: 'https://system-4.commercialweb.apps.test.ext.bcbssc.com/',
    system5: 'https://system-5.commercialweb.apps.test.ext.bcbssc.com/',
    system6: 'https://system-6.commercialweb.apps.test.ext.bcbssc.com/',
    system7: 'https://system-7.commercialweb.apps.test.ext.bcbssc.com/',
    system8: 'https://system-8.commercialweb.apps.test.ext.bcbssc.com/',
    qa1: 'https://qa-1.commercialweb.apps.test.ext.bcbssc.com/',
    qa2: 'https://qa-2.commercialweb.apps.test.ext.bcbssc.com/',
    productionAlpha: 'https://prod-alpha.commercialweb.apps.prod.ext.bcbssc.com/',
    productionOmega: 'https://prod-omega.commercialweb.apps.prod.ext.bcbssc.com/',
    production: 'https://prod-alpha.commercialweb.apps.prod.ext.bcbssc.com/'
};
export const defaultCommwebServiceBaseUrl
    = `${process.env.COMM_SERVICES_BASE_URL ?? commwebServiceBaseUrls.production}`;

// Base URLs for calling legacy MHTK service, namely for authentication
export const legacyCommwebServiceBaseUrls: Record<string, string> = {
    unit1: 'https://unit-1.myhealthtoolkit.com/',
    unit2: 'https://unit-2.myhealthtoolkit.com/',
    unit3: 'https://unit-3.myhealthtoolkit.com/',
    unit4: 'https://unit-4.myhealthtoolkit.com/',
    unit5: 'https://unit-5.myhealthtoolkit.com/',
    unit6: 'https://unit-6.myhealthtoolkit.com/',
    unit7: 'https://unit-7.myhealthtoolkit.com/',
    unit8: 'https://unit-8.myhealthtoolkit.com/',
    system1: 'https://system-1.myhealthtoolkit.com/',
    system2: 'https://system-2.myhealthtoolkit.com/',
    system3: 'https://system-3.myhealthtoolkit.com/',
    system4: 'https://system-4.myhealthtoolkit.com/',
    system5: 'https://system-5.myhealthtoolkit.com/',
    system6: 'https://system-6.myhealthtoolkit.com/',
    system7: 'https://system-7.myhealthtoolkit.com/',
    system8: 'https://system-8.myhealthtoolkit.com/',
    qa1: 'https://qa.bcbssc.com/',
    qa2: 'https://mim-qa.bcbssc.com/',
    production: 'https://www.myhealthtoolkit.com/'
};
export const defaultLegacyCommwebServiceBaseUrl
    = `${process.env.LEGACY_COMM_SERVICES_BASE_URL ?? legacyCommwebServiceBaseUrls.production}`;

// Configuration for calling LEDS services
export const ledsClientId = 'cd70ec10-4866-46c7-b45a-b7e37c2ec335';
export const ledsServiceBaseUrls: Record<string, string> = {
    unit: 'https://unit.api.bcbssc.com/',
    system: 'https://system.api.bcbssc.com/',
    qa: 'https://qa.api.bcbssc.com/',
    production: 'https://api.bcbssc.com/'
};
export const defaultLedsServiceBaseUrl = (
    defaultCommwebServiceBaseUrl.includes('unit') ? ledsServiceBaseUrls.unit
        : defaultCommwebServiceBaseUrl.includes('system')
        || defaultCommwebServiceBaseUrl.includes('isc')
            ? ledsServiceBaseUrls.system
            : defaultCommwebServiceBaseUrl.includes('qual') || defaultCommwebServiceBaseUrl.includes('qa')
                ? ledsServiceBaseUrls.qa
                : ledsServiceBaseUrls.production
);

// Configuration for calling AEM services
// TODO - this logic will need to change when nonsecure site is hosted on AEM.
export const defaultAemServiceBaseUrl = (() => {
    const hostSplit = window.location.host.split('.');
    if (hostSplit.length <= 2) {
        return 'https://secure.myhealthtoolkit.com/';
    }
    if (hostSplit.length > 3 && hostSplit.includes('employer')) {
        const [envPrefix, employerPrefix] = hostSplit;
        return `https://secure.${envPrefix}.${employerPrefix}.myhealthtoolkit.com/`;
    } else if (hostSplit.length === 3 && hostSplit.includes('employer')) {
        const [environment] = hostSplit;
        return `https://secure.${environment}.myhealthtoolkit.com/`;
    }
    const environment = hostSplit[hostSplit.length - 3];
    return `https://secure.${environment}.myhealthtoolkit.com/`;
})();
